<template>
  <th class="whitespace-nowrap bg-gray-50 border-b border-gray-300 sticky top-0 font-medium py-2 px-4 md:px-6 md:py-3">
    <slot />
  </th>
</template>
